import styled from "styled-components";
import { styledByTheme } from "../../../themes/architecture/styled-by-theme";

const WelcomeUserInfoDefaultBox = styled.p`
    margin: 0;
    line-height: 1;

    ${({theme}) => theme.font.presets.regular};
    font-size: 1.8rem;
    font-weight: 700;
    color: ${({theme}) => theme.colors.brandPrimary}; /* $brand-888-green; */
`;

const WelcomeUserInfoCasino777Box = styled(WelcomeUserInfoDefaultBox)`
    ${({theme}) => theme.font.presets.bold};
    font-size: 2rem;
    color: ${({theme}) => theme.colors.danger}; /* Color.red */
`;

export const WelcomeUserInfoBox = styledByTheme(WelcomeUserInfoDefaultBox).forCasino777(WelcomeUserInfoCasino777Box).apply();
